/** Natural A4 page width in CSS pixels — matches printer viewport. */
export const A4_WIDTH_PX = 794;
/** Single-page A4 height at 794px width. */
export const A4_HEIGHT_PX = 1123;
export const A4_ASPECT_RATIO = A4_WIDTH_PX / A4_HEIGHT_PX;

export function previewCanvasScale(hostWidth: number): number {
  return Math.min(1, hostWidth / A4_WIDTH_PX);
}

export function scaledPreviewDimensions(
  hostWidth: number,
  pageCount = 1,
): { scale: number; width: number; height: number; intrinsicHeight: number } {
  const scale = previewCanvasScale(hostWidth);
  const intrinsicHeight = Math.max(1, pageCount) * A4_HEIGHT_PX;
  return {
    scale,
    width: A4_WIDTH_PX * scale,
    height: intrinsicHeight * scale,
    intrinsicHeight,
  };
}
